export enum FeaturesEnum{
    SKILL_NAV,
    SKILL_ITEM_EDIT,
    CONSULTANT_VIEW,
    VIEW_ALL_EDUCATORS
}